import { SvgIcon } from '@material-ui/core';

function RadioIcon() {
  return (
    <SvgIcon>
      <path d="M20.5 12c0 2.311-.979 4.5-2.49 6.01A8.602 8.602 0 0 1 12 20.5c-2.311 0-4.5-.979-6.01-2.49A8.602 8.602 0 0 1 3.5 12c0-2.311.979-4.5 2.49-6.01A8.602 8.602 0 0 1 12 3.5c2.311 0 4.5.979 6.01 2.49A8.602 8.602 0 0 1 20.5 12zm-3.197-5.303C15.919 5.312 14.107 4.5 12 4.5c-2.107 0-3.919.812-5.303 2.197C5.312 8.081 4.5 9.893 4.5 12c0 2.107.812 3.919 2.197 5.303C8.081 18.688 9.893 19.5 12 19.5c2.107 0 3.919-.812 5.303-2.197C18.688 15.919 19.5 14.107 19.5 12c0-2.107-.812-3.919-2.197-5.303z" />
    </SvgIcon>
  );
}

export default RadioIcon;
